import { useState } from "react";
import TicketTypesTab from "./TicketTypesTab";
import TablesTab from "./tables/tablesPageTab";

const TABS = [
  { key: "tickets", label: "Tickets" },
  { key: "tables",  label: "Tables" },
];

const TicketsTablePage = ({
  event,
  onRefreshEvent,
  activeSubTab,
  onSubTabChange,
  isViewOnly, // ← CHANGE 1: accept prop
}) => {
  return (
    <div className="space-y-4">
      {/* TABS */}
      <div className="flex justify-evenly items-center border-b border-white/10">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            onClick={() => onSubTabChange(tab.key)}
            className={`pb-3 pl-20 pr-20 text-sm font-medium transition
              ${activeSubTab === tab.key
                ? "text-pink-500 border-b-2 border-pink-500"
                : "text-slate-400 hover:text-white"
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* CONTENT */}
      <div className="bg-slate-900/60 flex-1 border border-white/10 rounded-xl pt-5 pb-5 px-2">
        {activeSubTab === "tickets" && (
          <TicketTypesTab
            eventId={event.id}
            isViewOnly={isViewOnly} // ← CHANGE 2: forward to TicketTypesTab
          />
        )}
        {activeSubTab === "tables" && (
          <TablesTab
            event={event}
            onRefreshEvent={onRefreshEvent}
            isViewOnly={isViewOnly} // ← CHANGE 3: forward to TablesTab
          />
        )}
      </div>
    </div>
  );
};

export default TicketsTablePage;